import { extractStringFromCellValue } from "./utils/extractStringFromCellValue";

export const WIDGET_ELEM_someReqPropsUnset = widgetConfig => {
  const tableData = widgetConfig?.props?.tableData;
  
  if (!tableData?.data || !Array.isArray(tableData.data)) {
    return true; 
  }

  const hasValidData = tableData.data.some(row => {
    const keyCell = row.cellData?.[0];
    const valueCell = row.cellData?.[1];
    
    const keyString = extractStringFromCellValue(keyCell?.value);
    const value = valueCell?.value;
    
    if (!keyString.trim()) {
      return false; 
    }
    
    if (value === '' || value === null || value === undefined) {
      return false; 
    }
    
    const numericValue = typeof value === 'number' ? value : parseFloat(value);
    return !isNaN(numericValue) && numericValue >= 0;
  });

  return !hasValidData; 
}; 